import CheckoutPage from "./CheckoutPage";
import { connect } from "react-redux";
import { getCheckout, saveCheckout, pushToConfirmationPage, cancelCheckout } from "actions/webOrder";
import responseHandler from "responseHandler";

const mapStateToProps = (state) => ({
    confirmationNumber: state.webOrder.confirmationNumber,
    fetchingCheckout: state.webOrder.fetchingCheckout,
    savingCheckout: state.webOrder.savingCheckout,
    cancelingCheckout: state.webOrder.cancelingCheckout,
    checkout: state.webOrder.checkout
});

const mapDispatchToProps = (dispatch) => ({
    getCheckout(token) {
        dispatch(getCheckout(token));
    },
    cancelCheckout(token) {
        dispatch(cancelCheckout(token));
    },
    saveCheckout(token, orderData, callback) {
        dispatch(saveCheckout(token, orderData, callback));
    },
    makeToast(text, type) {
        responseHandler.customToast(text, type, dispatch);
    },
    pushToConfirmationPage() {
        dispatch(pushToConfirmationPage());
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutPage);
